import React from "react";
import { Card, ListGroup } from "react-bootstrap";

const RefundOrder = ({ data }) => {
    if (!data) {
        return <p style={{ textAlign: "center", color: "gray" }}>ບໍ່ພົບຂໍ້ມູນ</p>;
    }
    const {
        code,
        note,
        status,
        shopId,
        userId,
        orderGroupId,
    } = data;
    return (
        <Card style={{ borderRadius: "8px", boxShadow: "0 2px 6px rgba(0,0,0,0.1)" }}>
            <Card.Body>
                <h5 className="mb-3">ລາຍລະອຽດການສັ່ງຊື້</h5>
                <ListGroup variant="flush">
                    <ListGroup.Item>
                        <strong>ລະຫັດຄຳສັ່ງຊື້:</strong>{" "}
                        {orderGroupId?.code || "N/A"}
                    </ListGroup.Item>
                    <ListGroup.Item>
                        <strong>ລູກຄ້າ:</strong> {userId?.firstName || "N/A"}
                    </ListGroup.Item>
                    <ListGroup.Item>
                        <strong>ຮ້ານ:</strong> {shopId?.name || "N/A"}
                    </ListGroup.Item>
                    <ListGroup.Item>
                        <strong>ສະຖານະ:</strong>{" "}
                        <span
                            style={{
                                padding: "4px 8px",
                                borderRadius: "4px",
                                backgroundColor:
                                    status === "REFUND_PROCESSING" ? "#fff3cd" : "#d4edda",
                                color: status === "REFUND_PROCESSING" ? "#856404" : "#155724",
                            }}
                        >
                            {status === "REFUND_PROCESSING"
                                ? "ດໍາເນີນການຄືນເງິນ"
                                : status || "N/A"}
                        </span>
                    </ListGroup.Item>
                    <ListGroup.Item>
                        <strong>ໝາຍເຫດ:</strong>{" "}
                        {note || "ບໍ່ມີໝາຍເຫດ"}
                    </ListGroup.Item>
                </ListGroup>

                <hr />

                <h6 className="mt-3">ລາຍການສິນຄ້າ</h6>
                {orderGroupId?.orders?.length > 0 ? (
                    <ListGroup variant="flush">
                        {orderGroupId.orders.map((item, index) => (
                            <ListGroup.Item key={index}>
                                {index + 1}. {item.productName}
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                ) : (
                    <p style={{ color: "gray" }}>ບໍ່ມີລາຍການສິນຄ້າ</p>
                )}

                <hr />

                <div className="mt-2">
                    <p>
                        <strong>ຈຳນວນ:</strong>{" "}
                        {orderGroupId?.amount || 0}
                    </p>
                    <p>
                        <strong>ລາຄາລວມ:</strong>{" "}
                        {orderGroupId?.sumPrice?.toLocaleString() || 0} ₭
                    </p>
                    <p>
                        <strong>ລາຄາທັງໝົດ:</strong>{" "}
                        {orderGroupId?.totalPrice?.toLocaleString() || 0} ₭
                    </p>
                </div>
            </Card.Body>
        </Card>
    );
};

export default RefundOrder;
